import { forwardRef } from 'react';
import { Copy16, Directions16, Location16 } from '@elfsight/icons';
import { copyTextToClipboard } from '@elfsight/lib-utils';
import { openWindow } from '@elfsight/widget-utils';
import type { DropdownProps } from '../dropdown';
import { Dropdown, DropdownItem } from '../dropdown';

const GM_PLACE_URL = 'https://www.google.com/maps/search';
const GM_DIR_URL = 'https://www.google.com/maps/dir/Your+Location';

export type GoogleMapsDirectionDropdownProps = Omit<
  DropdownProps,
  'children'
> & {
  address: string;
  name: string;
  phrases?: {
    open: string;
    getDirection: string;
    copy: string;
  };
};

export const GoogleMapsDirectionDropdown = forwardRef<
  HTMLDivElement,
  GoogleMapsDirectionDropdownProps
>(function GetDirectionDropdown(
  {
    address,
    name,
    popoutDirection = 'upward',
    phrases = {
      open: 'Open in Google Maps',
      getDirection: 'Get Directions',
      copy: 'Copy'
    },
    ...forwardingProps
  },
  forwardingRef
) {
  return (
    <Dropdown
      {...forwardingProps}
      ref={forwardingRef}
      popoutDirection={popoutDirection}
      style={{ borderRadius: 8 }}
    >
      <DropdownItem
        icon={Location16}
        onClick={() =>
          openWindow(
            `${GM_PLACE_URL}/"${encodeURIComponent(name)}", ${encodeURIComponent(address)}`,
            {
              target: '_blank'
            }
          )
        }
      >
        {phrases.open}
      </DropdownItem>
      <DropdownItem
        icon={Directions16}
        onClick={() =>
          openWindow(`${GM_DIR_URL}/${name}, ${address}`, {
            target: '_blank'
          })
        }
      >
        {phrases.getDirection}
      </DropdownItem>
      <DropdownItem
        icon={Copy16}
        onClick={() => copyTextToClipboard(`${name}, ${address}`)}
      >
        {phrases.copy}
      </DropdownItem>
    </Dropdown>
  );
});
